export default {
  endChat: 'End Conversation',
  recommend: 'Hot Recommendation',
  send: 'Send',
  preview: 'Preview',
  download: 'Download',
  unfold: 'Unfold',
  fold: 'Fold',
  playVideo: 'Click to play video',
  inputQA: 'Please enter your question',
  goToHuman: "Sorry, we still can't understand what you mean, we recommend clicking 'Human Customer Service' below to provide you with further services.",
  customerService: 'Human customer service',
  satisfied: 'Satisfied',
  unsatisfied: 'Unsatisfied',
  more: 'More',
  clickToman: 'Click here for human service',
  feedback: 'Thank you for your feedback',
  mandarin: 'Mandarin',
  cantonese: 'Cantonese',
  notMediaSupport: "This video can't play,please try again later",
  want: 'Guess you want to ask：',
  callEnd: 'Conversation Ended',
  reloadCall: 'Refresh to talk again',
  ttsFail: 'Voice synthesis failed!',
  synthesising: 'Speech synthesising...',
  inSpeechRecognition: 'In speech recognition...',
  pressToSpeak: 'Press and hold to speak',
  cancelSend: 'Cancel sending',
  transException: 'Transform to text exception',
  remaining: 'Stop recording after {0} seconds',
  quitTips: 'Time out, system quit',
  timeOutTips: 'Time out, send a question to reconnect',
  defaultRobot: 'Xiao Man, Intelligent Customer Service',
  welcome: 'Hello, what can I do for you?',
  ttsEmpty: 'There is no broadcastable content at the moment'
}